import PropTypes from 'prop-types';
import { Circle, Donut } from 'assets/icons';
import { grey50, ctaGreen } from 'constants/variables';

const StockStatus = ({ outOfStock, children }) => (
  <div className="stock-level fl ai-fs">
    <div className="fl ai-c jc-c pt-5">
      {outOfStock ? <Donut fill={grey50} /> : <Circle fill={ctaGreen} />}
    </div>
    <p className="fl-1 ml-4 mb-0">{children}</p>
  </div>
);

StockStatus.propTypes = {
  outOfStock: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default StockStatus;
